import PropTypes from 'prop-types';
import clsx from 'clsx';
import styles from './DamSummary.module.css';
import BigStat from './BigStat.jsx';
import { determineLevelAboveBelow, determineStorage } from '../helpers/DamHelper.js';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@awesome.me/kit-2be97ecbd6/icons/classic/solid';

function DamSummary({ dam, damMeta, error, title, link }) {
  const {t} = useTranslation();
  console.log("DamSummary", dam, damMeta, link);
  
  const damSiteMeta = damMeta?.site;
  const damSite = dam?.siteSummary?.find(site => site.id === damSiteMeta?.id);
  
  const storageStats = determineStorage(t, damSiteMeta, damSite?.lastValue);
  
  return (
    <div className={styles.DamSummaryContainer}>
      <div className={styles.DamSummaryHeader}>
        <h4>{title}</h4>
      </div>
      <div className={styles.DamSummaryStats}>
        <BigStat
          stat={storageStats?.percent ? (storageStats?.percent * 100).toFixed(2) : undefined}
          unit={'%'}
          secondStat={determineLevelAboveBelow(t, damSiteMeta, damSite?.lastValue)}
        />
      </div>
      <div className={styles.DamSummaryAction}>
        {link && (
          <a href={link} className={clsx(styles.DamSummaryBtn, 'btn', 'btn-link')}>
            View Dam Details<FontAwesomeIcon icon={faArrowRight} className={styles.DamSummaryBtnIcon} />
          </a>
        )}
      </div>
    </div>
  );
};

DamSummary.propTypes = {
  dam: PropTypes.object,
  damMeta: PropTypes.object,
  error: PropTypes.bool,
  title: PropTypes.string.isRequired,
  link: PropTypes.string,
};

export default DamSummary;
